// Instant cart: show the result of "Add to cart" and +/- right away,
// while the theme's normal request to Shopify runs in the background.
// When Shopify answers, the theme redraws the drawer with the exact figures
// (discounts, stock limits). If Shopify refuses, the change is rolled back.
(() => {
  const formatMoney = (cents) => {
    const format =
      window.cartStrings?.money_format ||
      window.themeGlobalVariables?.settings?.money_format;
    if (window.Shopify?.formatMoney && format) {
      return window.Shopify.formatMoney(Math.round(cents), format);
    }
    return (cents / 100).toFixed(2);
  };
  const drawerForm = () => document.getElementById("minicart-form");
  const drawerWrapper = () =>
    document.querySelector("#minicart_wrapper .minicart__wrapper");

  // ---------- Totals: server figures + what the shopper changed since ----------
  function recalc() {
    const form = drawerForm();
    if (!form) return;
    const subtotalEl = form.querySelector("[data-cart-subtotal-price]");
    const baseTotal = Number(subtotalEl?.dataset.cartTotal || 0);
    const baseCount = Number(subtotalEl?.dataset.cartCount || 0);
    const baseItems = Number(subtotalEl?.dataset.itemsSubtotal || 0);
    let deltaPrice = 0;
    let deltaCount = 0;

    form.querySelectorAll(".cart-item[data-line-price]").forEach((line) => {
      const serverQty = Number(line.dataset.shippingProtectionQuantity || 0);
      const input = line.querySelector('input[name="updates[]"]');
      if (!input || !serverQty) return;
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      const unit = Number(line.dataset.linePrice) / serverQty;
      deltaPrice += (qty - serverQty) * unit;
      deltaCount += qty - serverQty;
      line.classList.toggle("ci-removing", qty === 0);
    });
    form.querySelectorAll(".ci-temp-line").forEach((line) => {
      deltaPrice += Number(line.dataset.linePrice || 0);
      deltaCount += Number(line.dataset.qty || 0);
    });

    if (subtotalEl) subtotalEl.textContent = formatMoney(Math.max(0, baseTotal + deltaPrice));
    const count = Math.max(0, baseCount + deltaCount);
    document.querySelectorAll(".cart-count").forEach((el) => {
      if (el.classList.contains("cart-count-drawer")) el.innerHTML = `(${count})`;
      else el.innerHTML = count > 100 ? "~" : count;
    });
    document
      .querySelector("free-ship-progress-bar")
      ?.init?.(Math.max(0, baseItems + deltaPrice));
  }

  function revert() {
    const form = drawerForm();
    if (!form) return;
    form.querySelectorAll(".ci-temp-line, .ci-temp-holder").forEach((el) => el.remove());
    form.querySelector(".cart-empty")?.closest(".cart-body")?.classList.remove("ci-hidden");
    form.querySelectorAll(".cart-item[data-line-price]").forEach((line) => {
      const input = line.querySelector('input[name="updates[]"]');
      if (input) input.value = line.dataset.shippingProtectionQuantity;
    });
    recalc();
  }

  document.addEventListener("cart:instant-recalc", recalc);
  // Shopify refused a change (e.g. not enough stock): reload the true cart from
  // Shopify, then show the theme's error message on that line again
  document.addEventListener("cart:instant-revert", (e) => {
    revert();
    const { line, message } = e.detail || {};
    const done = window.cartSyncNow ? window.cartSyncNow() : Promise.resolve();
    done.then(() => {
      if (!line || !message) return;
      const text = document.querySelector(
        `#CartDrawer-LineItemError-${CSS.escape(line)} .cart-item__error-text`
      );
      if (text) text.textContent = message;
    });
  });

  // +/- buttons and typed quantities: update totals on the same tap
  document.addEventListener(
    "change",
    (e) => {
      if (e.target?.matches?.('#minicart_wrapper input[name="updates[]"]')) recalc();
    },
    true
  );

  // ---------- Add to cart: open the drawer on the tap ----------
  const busy = (on) => drawerWrapper()?.classList.toggle("ci-busy", on);

  const productInfo = (variantId) => {
    const meta = window.ShopifyAnalytics?.meta?.product;
    const variant = meta?.variants?.find((v) => String(v.id) === String(variantId));
    const title =
      document.querySelector(".product-detail__information h1, .product__title, h1")
        ?.textContent.trim() || variant?.name || "";
    const img = [...document.querySelectorAll("media-gallery img, .product__media img")]
      .find((i) => i.currentSrc && i.offsetParent);
    return { title, price: variant ? Number(variant.price) : null, image: img?.currentSrc || "" };
  };

  const tempLine = ({ title, price, image }, qty) => {
    const el = document.createElement("div");
    el.className = "cart-item ci-temp-line flex mb-20 pb-20 gap-15 border-bottom-dashed";
    el.dataset.qty = qty;
    el.dataset.linePrice = price != null ? price * qty : 0;
    const safe = (t) => t.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
    el.innerHTML = `
      <div class="minicart__product__image w-custom fs-0 relative" style="--custom-width: 9rem">
        ${image ? `<img src="${safe(image)}" alt="" class="rounded-5" style="width:100%;height:auto">` : ""}
      </div>
      <div class="minicart__product-info flex-1 relative flex flex-column">
        <h3 class="minicart__product-name my-0 text-size"><span class="heading-color">${safe(title)}</span></h3>
        ${price != null ? `<div class="minicart__item-prices mt-3"><span class="minicart__item-price heading_weight primary-color">${formatMoney(price)}</span></div>` : ""}
        <div class="mt-6 fs-small dark-grey">× ${qty}</div>
      </div>`;
    return el;
  };

  let pendingAdd = null;

  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      const cart = document.querySelector("cart-notification");
      if (!cart || !form.closest || !form.closest("product-form")) return;
      if (form.closest(".tingle-modal") || document.body.classList.contains("template-cart")) return;
      const button = form.querySelector('[type="submit"]');
      if (button?.getAttribute("aria-disabled") === "true") return;
      const data = new FormData(form);
      const variantId = data.get("id");
      const qty = Math.max(1, parseInt(data.get("quantity"), 10) || 1);
      if (!variantId) return;

      const drawer = drawerForm();
      const existing = drawer?.querySelector(
        `.cart-item[data-shipping-protection-key^="${variantId}:"] input[name="updates[]"]`
      );
      pendingAdd = { variantId };
      if (existing) {
        existing.value = (parseInt(existing.value, 10) || 0) + qty;
      } else if (drawer) {
        const items = drawer.querySelector(".items");
        const line = tempLine(productInfo(variantId), qty);
        if (items) {
          items.prepend(line);
        } else {
          const body = drawer.querySelector(".cart-empty")?.closest(".cart-body");
          body?.classList.add("ci-hidden");
          const holder = document.createElement("div");
          holder.className = "minicart-body px-30 ci-temp-holder";
          holder.appendChild(line);
          (drawer.querySelector("form#minicart") || drawer).prepend(holder);
        }
      }
      recalc();
      busy(true);
      cart.open?.();
    },
    true
  );

  // Watch the theme's own add request to end the busy state or roll back
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const promise = origFetch.apply(this, arguments);
    try {
      const url = typeof input === "string" ? input : input?.url || "";
      if (pendingAdd && /\/cart\/add(\.js)?(\?|$)/.test(url) && (init?.method || "").toUpperCase() === "POST") {
        pendingAdd = null;
        promise
          .then((res) => res.clone().json().then((json) => ({ ok: res.ok, json })))
          .then(({ ok, json }) => {
            if (!ok || json.status) {
              revert();
              window.cartSyncNow?.();
              document.querySelector("cart-notification")?.close?.();
            }
          })
          .catch(() => revert())
          .finally(() => setTimeout(() => busy(false), 60));
      }
    } catch (err) {}
    return promise;
  };
})();
